// Module2.js
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
import { Grid, Header } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { hasText, htmlHasContent } from "../guiaHelpers";
import "./Module2.scss";

const virtualScenesController = new VirtualScenes();

export function Module2({ refId, onlyLeftColumn = false }) {
  const module2 = "module_02";
  const { accessToken } = useAuth();
  const { t } = useTranslation("scenes");

  const [moduleData, setModuleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module2,
      );
      setModuleData(data.moduleData);
    } catch (err) {
      console.error("Error al obtener los datos del módulo:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module2]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading || error) return null;

  const { ModOneTitle, ModOneIntroduction, ModOneObjetives, ModOneLevels } =
    moduleData || {};

  const hasLeft = hasText(ModOneTitle) || htmlHasContent(ModOneIntroduction);
  const hasRight =
    !onlyLeftColumn &&
    (htmlHasContent(ModOneObjetives) || hasText(ModOneLevels));

  if (!hasLeft && !hasRight) return null;

  const leftColumnWidth = onlyLeftColumn || !hasRight ? 16 : 8;

  return (
    <div className="module2-container">
      <Grid stackable columns={2} className="module2-grid">
        {/* Columna Izquierda */}
        {hasLeft && (
          <Grid.Column width={leftColumnWidth}>
            <div className="framed-box">
              {hasText(ModOneTitle) && (
                <Header as="h2" className="block-title">
                  {ModOneTitle}
                </Header>
              )}
              {htmlHasContent(ModOneIntroduction) && (
                <div
                  className="module2-description"
                  dangerouslySetInnerHTML={{ __html: ModOneIntroduction }}
                />
              )}
            </div>
          </Grid.Column>
        )}

        {/* Columna Derecha */}
        {hasRight && (
          <Grid.Column width={8}>
            <div className="framed-box">
              {htmlHasContent(ModOneObjetives) && (
                <>
                  <Header as="h3" className="block-title">
                    {t("guide.objectives")}
                  </Header>
                  <div
                    className="module2-objectives-list"
                    dangerouslySetInnerHTML={{ __html: ModOneObjetives }}
                  />
                </>
              )}

              {hasText(ModOneLevels) && (
                <>
                  <Header as="h3" className="block-title">
                    {t("guide.level")}
                  </Header>
                  <p className="module2-level">{ModOneLevels}</p>
                </>
              )}
            </div>
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
}
